import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.16.2_@azure+identity@4.8.0_@parcel+watcher@2.5.1_@types+node@22.0.0_db0@0.3.1_ioredis@_xh6s36qx4ibz4tjsyubyprs3y4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}